<template>
    <div
            class="property-details-photo-gallery w-100"
            @click.stop="displayGallery(0)"
    >
        <b-skeleton-wrapper>
            <template #loading>
                <b-skeleton class="images-loading-placeholder" />
            </template>
            <div class="d-flex w-100">
                <property-mls-sponsor-logo class="position-absolute" />
                <property-listing-card-labels
                        :hide-on-balloon="true"
                        :property-app-resource="propertyAppResource"
                        class="m-1"
                />
                <template v-if="mainImageSrc">
                    <b-img
                            :src="mainImageSrc"
                            class="main-image img-fluid"
                    />
                    <template v-if="secondImageSrc">
                        <div
                                class="right-side-images d-none d-xl-flex flex-column pl-xl-2 w-100"
                        >
                            <b-img
                                    :src="secondImageSrc"
                                    :style="secondImageStyle"
                                    class="second-image"
                                    @click.stop="displayGallery(1)"
                            />
                            <template v-if="thirdImageSrc">
                                <b-img
                                        :src="thirdImageSrc"
                                        class="third-image mt-2"
                                        @click.stop="displayGallery(2)"
                                />
                                <div class="total-images pr-2 pl-2 p-1 ml-auto position-relative">
                                    <i class="total-icon fal fa-image" />
                                    {{ images.length }}
                                </div>
                            </template>
                        </div>
                    </template>
                </template>
                <template v-else>
                    <div class="d-flex no-img justify-content-center align-items-center flex-column flex-sm-row w-100">
                        <i class="far fa-images mr-sm-3" />
                        <h3 class="mb-0 text-center">
                            No photos yet... check back later!
                        </h3>
                    </div>
                </template>
            </div>
        </b-skeleton-wrapper>
    </div>
</template>

<script>
    import './PropertyDetailsPhotoGallery.scss';
    import './PropertyDetailsPhotoGallery.mobile.scss';
    import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
    import PropertyListingCardLabels from '../../../PropertyListingCard/PropertyListingCardLabels';
    import PropertyMlsSponsorLogo from '../../PropertyMlsSponsor/PropertyMlsSponsorLogo';

    export default {
        name: "PropertyListingPhotoGallery",
        components: {
            PropertyListingCardLabels,
            PropertyMlsSponsorLogo,
        },
        props: {
            propertyAppResource: {
                type: AppResource,
                required: true,
            },
            images: {
                type: Array,
                required: true
            },
        },
        computed: {
            secondImageStyle() {
                let style = {
                    height: '410px'
                };

                if (this.thirdImageSrc) {
                    style.height = '202px';
                }

                return style;
            },

            mainImageSrc() {
                if (!this.images.length) {
                    return '';
                }
                let url = new URL(this.images[0]);
                url.searchParams.append('width', !this.secondImageSrc ? 1280 : 780);
                url.searchParams.append('height', !this.secondImageSrc ? 210 : 390);
                return url.href;
            },
            secondImageSrc() {
                if (this.images.length <= 1) {
                    return '';
                }
                let url = new URL(this.images[1]);
                url.searchParams.append('width', 500);

                url.searchParams.append('height', !this.thirdImageSrc ? 410 : 205);
                return url.href;
            },
            thirdImageSrc() {
                if (this.images.length <= 2) {
                    return '';
                }
                let url = new URL(this.images[2]);
                url.searchParams.append('width', 500);
                url.searchParams.append('height', 205);
                return url.href;
            },
        },
        methods: {
            displayGallery(imageIndex) {
                this.$emit('display', imageIndex);
            },
        },

    };
</script>
